export default __webpack_public_path__ + "static/media/customerIconMobile.0279c9aa.png";